/**
 * 接口路径统一管理模块
 */

import { del, get, post, put } from './http'

// 栏目列表
export const getCategoryList = (params: any = {}) => get('/api/category/list?__ajax=json', params)
// 包含文章的栏目列表
export const getTreeList = (params: any = {}) => get('/api/category/treeList', params)
// 栏目子列表
export const getChildList = (params: any = {}) => get('/api/category/list?__ajax=json', params)
// 文章列表
export const getArticleList = (params: any = {}) => get('/api/article/listData', params)
// 文章详情页
export const articleDetail = (params: any = {}) => post('/api/view-' + params.code + '-' + params.id + '?__ajax=json', params)
// 轮播图
export const getBanners = (params: any = {}) => get('/api/banners', params)
// logo列表
export const getCiicLogo = (params: any = {}) => get('/api/ciicLogo', params)
// 获取验证码
export const getCaptcha = (params: any = {}) => get('/api/captcha', { ...params, withCredentials: true, responseType: 'blob' })
// 提交需求信息
export const saveInfo = (params: any = {}) => post('/api/cooperative/partner', { ...params, withCredentials: true })
